import React from 'react';
import '../styles/ActivityPanel.scss';

const ActivityPanel = ({ activities, onClose }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const getActionIcon = (action) => {
    const icons = {
      create_folder: '📁',
      upload_file: '⬆️',
      delete_file: '🗑️',
      grant_permission: '🔐',
      revoke_permission: '🔓',
    };
    return icons[action] || '📝';
  };

  return (
    <div className="activity-panel-overlay">
      <div className="activity-panel">
        <div className="panel-header">
          <h3>Recent Activities</h3>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="activities-list">
          {activities.length > 0 ? (
            activities.map((activity) => (
              <div key={activity.id} className="activity-item">
                <span className="activity-icon">
                  {getActionIcon(activity.action)}
                </span>
                <div className="activity-details">
                  <p className="activity-action">
                    {activity.action.replace('_', ' ').toUpperCase()}
                  </p>
                  <p className="activity-resource">
                    {activity.resource_type}: {activity.resource_id}
                  </p>
                  <p className="activity-time">
                    {formatDate(activity.created_at)}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="no-activities">No activities yet</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityPanel;
